import { Col, Row, Form, Select, Input } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Option } from "./AddEditSupplier";

type props = {
  setIsCountrySelected: any;
  formatedCountry: Option[] | undefined;
  loadingCountry: boolean;
};

function AddressInformation({
  formatedCountry,
  loadingCountry,
  setIsCountrySelected,
}: props) {
  const [t] = useTranslation("common");

  //MAP

  // const [clickedLatLng, setClickedLatLng] = useState<{
  //   lat: number;
  //   lng: number;
  // } | null>(null);

  // const { id } = useParams();
  // const form = Form.useFormInstance();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  // const { getFieldValue, setFieldsValue } = form;

  // useEffect(() => {
  //   if (!isEdit()) {
  //     setFieldsValue({
  //       addressLine2: `${clickedLatLng?.lat},${clickedLatLng?.lng}`,
  //     });
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [clickedLatLng]);

  const [postalCode, setPostalCode] = useState("");
  const [, setErrorMessage] = useState("");

  const handlePostalCodeChange = (event: any) => {
    const inputValue = event.target.value;
    const formattedValue = inputValue.replace(/[^A-Za-z0-9-]/g, "");
    setPostalCode(formattedValue);
    if (!/[^A-Za-z0-9-]/g) {
      setErrorMessage(
        "Postal Code can only contain letters , numbers and spaces"
      );
    } else {
    }
  };

  const handleKeyPress = (event: any) => {
    const key = event.key;
    const validCharacters = /^[A-Za-z0-9-]+$/;
    if (!validCharacters.test(key)) {
      event.preventDefault();
    }
  };
  const handleCountryChange = (value: any) => {
    setIsCountrySelected(value);
  };

  // const isEdit = () => {
  //   return !!id;
  // };

  return (
    <>
      <Row>
        <Col md={6}>
          <Form.Item
            name="countryId"
            label={`${t("country")}`}
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Select
              onChange={handleCountryChange}
              showSearch={true}
              optionFilterProp="label"
              data-testid="country"
              loading={loadingCountry}
              options={formatedCountry}
              placeholder={`${t("select-country")}`}
            />
          </Form.Item>

          <Form.Item name="city" label={`${t("city")}`}>
            <Input
              maxLength={50}
              autoComplete="off"
              placeholder={`${t("enter-text")}`}
              data-testid="city-input"
            />
          </Form.Item>

          <Form.Item name="addressLine1" label={`${t("address")}`}>
            <Input
              autoComplete="off"
              placeholder={`${t("enter-text")}`}
              data-testid="adderss-input"
            />
          </Form.Item>

          <Form.Item name="postalCode" label={`${t("postal-code")}`}>
            <Input
              maxLength={20}
              autoComplete="off"
              placeholder={`${t("enter-text")}`}
              data-testid="postal-code"
              value={postalCode}
              onChange={handlePostalCodeChange}
              onKeyPress={handleKeyPress}
            />
          </Form.Item>
        </Col>

        {/* <Col style={{ marginTop: "20px" }} offset={2} md={10}>
          <Col style={{ width: "100%" }} span={20}>
            <div style={{ display: "flex", alignItems: "center" }}>
              <Form.Item
                name="addressLine2"
                label={`${t("location")}`}
                style={{ flex: 1 }}
              >
                <Input
                  disabled
                  autoComplete="off"
                  style={{ width: "100%" }}
                  suffix={
                    <Tooltip>
                      <SearchOutlined style={{ color: "rgba(0,0,0,.45)" }} />
                    </Tooltip>
                  }
                />
              </Form.Item>
              <span
                style={{
                  marginLeft: "30px",
                  marginTop: "20px",
                  color: "#B8A5A5",
                }}
              >
                {t("or-select-location-on-map")}
              </span>
            </div>
          </Col>
          <div
            style={{
              width: "700px",
              height: "300px",
            }}
            id="map"
          >
            <Map
              setClickedLatLng={setClickedLatLng}
              clickedLatLng={clickedLatLng}
            />
          </div>
        </Col> */}
      </Row>
    </>
  );
}

export default AddressInformation;
